(function () {
  var sectionSelector = ".product.wd-product-template";
  var portaledClass = "wd-zoom-modal--portaled";

  var clearStickyInlineStyles = function (section) {
    var mediaContainer = section.querySelector(".product-media__container");

    if (mediaContainer) {
      mediaContainer.style.top = "";
    }

    section.style.top = "";
  };

  var applyThumbGap = function (swiper, gap, slideWidth) {
    swiper.params.spaceBetween = gap;
    swiper.params.slidesPerView = "auto";
    swiper.params.breakpoints = {};

    if (swiper.originalParams) {
      swiper.originalParams.spaceBetween = gap;
      swiper.originalParams.slidesPerView = "auto";
      swiper.originalParams.breakpoints = {};
    }

    swiper.update();

    swiper.slides.forEach(function (slide, index) {
      slide.style.setProperty("width", slideWidth + "px", "important");

      if (index < swiper.slides.length - 1) {
        slide.style.setProperty("margin-right", gap + "px", "important");
      } else {
        slide.style.removeProperty("margin-right");
      }
    });
  };

  var patchThumbnailSwiper = function (section, attempt) {
    var sectionId = section.dataset.sectionId;

    if (!sectionId) {
      return;
    }

    var thumbEl = section.querySelector(
      ".js-product-media-slider-thumbnails-" + sectionId,
    );

    if (!thumbEl || !thumbEl.swiper) {
      if ((attempt || 0) < 12) {
        window.setTimeout(function () {
          patchThumbnailSwiper(section, (attempt || 0) + 1);
        }, 100);
      }

      return;
    }

    var swiper = thumbEl.swiper;
    var isDesktop = window.innerWidth >= 1200;
    var gap = isDesktop ? 12 : 8;
    var slideWidth = isDesktop ? 104 : 64;

    swiper.params.freeMode = true;
    swiper.params.watchSlidesProgress = true;
    applyThumbGap(swiper, gap, slideWidth);

    if (isDesktop) {
      thumbEl.style.setProperty("width", "100%", "important");
      thumbEl.style.removeProperty("max-width");
    } else {
      thumbEl.style.removeProperty("width");
      thumbEl.style.removeProperty("max-width");
    }

    if (!thumbEl.dataset.wdThumbGapBound) {
      thumbEl.dataset.wdThumbGapBound = "true";

      swiper.on("update", function () {
        var desktop = window.innerWidth >= 1200;
        var width = desktop ? 104 : 64;
        var spacing = desktop ? 12 : 8;

        if (swiper.params.spaceBetween !== spacing) {
          swiper.params.spaceBetween = spacing;
        }

        if (desktop) {
          thumbEl.style.setProperty("width", "100%", "important");
          thumbEl.style.removeProperty("max-width");
        }

        swiper.slides.forEach(function (slide, index) {
          slide.style.setProperty("width", width + "px", "important");

          if (index < swiper.slides.length - 1) {
            slide.style.setProperty("margin-right", spacing + "px", "important");
          } else {
            slide.style.removeProperty("margin-right");
          }
        });
      });
    }
  };

 var patchMainSwiper = function (section, attempt) {
  var sectionId = section.dataset.sectionId;

  if (!sectionId) {
    return;
  }

  var mainEl = section.querySelector(".js-product-media-slider-" + sectionId);

  if (!mainEl || !mainEl.swiper) {
    if ((attempt || 0) < 20) {
      window.setTimeout(function () {
        patchMainSwiper(section, (attempt || 0) + 1);
      }, 100);
    }

    return;
  }

  mainEl.swiper.update();
};

  var getZoomModal = function (section) {
    var sectionId = section.dataset.sectionId;

    return (
      section.querySelector("[data-zoom-modal]") ||
      (sectionId
        ? document.getElementById("ZoomMediaModal-" + sectionId)
        : null)
    );
  };

  var getZoomSwiper = function (modal) {
    var sliderEl = modal && modal.querySelector("[data-zoom-slider]");

    return sliderEl && sliderEl.swiper ? sliderEl.swiper : null;
  };

  var isModalOpen = function (modal) {
    return (
      modal.classList.contains("is-active") ||
      modal.classList.contains("is-open")
    );
  };

  var closeZoomModal = function (modal) {
    if (!modal || !isModalOpen(modal)) {
      return;
    }

    var swiper = getZoomSwiper(modal);

    if (swiper && swiper.zoom) {
      swiper.zoom.out();
    }

    if (window.themeCore && window.themeCore.utils && window.themeCore.utils.overlay) {
      window.themeCore.utils.overlay({ namespace: modal.id }).close();
    }

    modal.classList.remove("is-active", "is-open");
    document.body.classList.remove("scroll-padding-0");
    document.body.style.overflow = "";

    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.emit("Toggle:" + modal.id + ":close", modal);
    }
  };

  var portalZoomModal = function (modal) {
    if (!modal || modal.parentElement === document.body) {
      return;
    }

    document.body.appendChild(modal);
    modal.classList.add(portaledClass);
  };

  var bindZoomModal = function (section) {
    var modal = getZoomModal(section);

    if (!modal || modal.dataset.wdZoomBound === "true") {
      return;
    }

    portalZoomModal(modal);
    modal.dataset.wdZoomBound = "true";

    var closeButton = modal.querySelector("[data-zoom-modal-toggle]");

    if (closeButton) {
      closeButton.addEventListener(
        "click",
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeZoomModal(modal);
        },
        true,
      );
    }

    modal.addEventListener("click", function (event) {
      if (event.target.closest("[data-zoom-modal-toggle], .modal__close")) {
        return;
      }

      var swiper = getZoomSwiper(modal);

      if (!swiper || !swiper.zoom) {
        return;
      }

      var slide = event.target.closest("[data-zoom-slide]");

      if (!slide) {
        return;
      }

      if (event.target.closest(".swiper-button-next, .swiper-button-prev")) {
        return;
      }

      if (swiper.zoom.scale && swiper.zoom.scale > 1) {
        swiper.zoom.out();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" || !isModalOpen(modal)) {
        return;
      }

      var swiper = getZoomSwiper(modal);

      if (swiper && swiper.zoom && swiper.zoom.scale && swiper.zoom.scale > 1) {
        event.preventDefault();
        swiper.zoom.out();
        return;
      }

      event.preventDefault();
      closeZoomModal(modal);
    });
  };

  var patchGallery = function (section) {
    var mediaContainer = section.querySelector(".js-product-media-container");

    if (!mediaContainer || mediaContainer.dataset.mediaLayout !== "carousel") {
      return;
    }

    clearStickyInlineStyles(section);
    patchThumbnailSwiper(section);
    patchMainSwiper(section);
  };

  var patchGalleryAfterZoom = function (section) {
    patchGallery(section);
    bindZoomModal(section);
  };

  var initAfterProductLoaded = function () {
    document.querySelectorAll(sectionSelector).forEach(patchGalleryAfterZoom);
  };

  var initGalleryOnly = function () {
    document.querySelectorAll(sectionSelector).forEach(patchGallery);
  };

  if (window.themeCore && window.themeCore.EventBus) {
    window.themeCore.EventBus.listen("product:loaded", function () {
      window.setTimeout(initAfterProductLoaded, 0);
    });
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      window.setTimeout(initAfterProductLoaded, 250);
    });
  }

  window.addEventListener("resize", initGalleryOnly);

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(sectionSelector);

    if (section) {
      window.setTimeout(function () {
        patchGalleryAfterZoom(section);
      }, 250);
    }
  });
})();
